import { Row } from '@tanstack/react-table'
import { isAfter, isBefore, parseISO } from 'date-fns'

export const filterByDateAndTime = <T>(
    row: Row<T>,
    columnId: string,
    filterValue: { from?: string; to?: string }
): boolean => {
    const value = row.getValue<string>(columnId)
    if (!value) return false

    let dateTime: Date
    try {
        dateTime = parseISO(value)
    } catch {
        return false
    }

    if (filterValue.from) {
        try {
            const from = parseISO(filterValue.from)
            if (isBefore(dateTime, from)) return false
        } catch {
            return false
        }
    }

    if (filterValue.to) {
        try {
            const to = parseISO(filterValue.to)
            if (isAfter(dateTime, to)) return false
        } catch {
            return false
        }
    }

    return true
}
